import React from 'react'
import { Link } from 'react-router-dom';
import Pages_1 from '../../assets/images/background/service-page-bg.jpg';
import Pages_2 from '../../assets/images/about/arrow-brudcrumb.svg';


const PageHeader = ({ Title, Subtitle }) => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: `url(${Pages_1})`,
                  }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-8">
                            <div
                                className="page-header-heading animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <h2>{Title}</h2>
                                <p className="lead">
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews. Iterative approaches to collaborative .
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={Pages_2} alt="icon" />
                        </li>
                        <li>
                            <span>{Subtitle}</span>
                        </li>
                    </ul>
                </div>
            </div>

        </>
    )
}

export default PageHeader
